export default __webpack_public_path__ + "static/media/In.ca590743.png";